import "./sidebar.scss";
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import cancelIcon from "../../assets/icons/cancel-green.svg";
import whiteCancelIcon from "../../assets/icons/cancel-white.svg";

const Sidebar = ({ showSidebar, setShowSidebar }) => {
  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  useEffect(() => {
    console.log(window.screen.width);
    if (window.screen.width < 1535) {
      setShowSidebar(false);
    }
  }, [window.screen.width]);

  // handlers
  const scrollToFooter = () => {
    const footerSection = document.getElementById("footer-sec");
    if (footerSection) {
      footerSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className={`menu relative z-50  ${darkThemeFromStore ? "dark-back" : ""}`}
    >
      <svg
        onClick={() => setShowSidebar(!showSidebar)}
        className={`menu-icon z-30  items-center cursor-pointer m-2 mr-0 ml-4 xm:w-[20px] xlg:w-[40px] right-3 ${
          darkThemeFromStore ? "white-rec" : ""
        }`}
        fill="#fff"
        viewBox="0 0 100 80"
        width="28"
        height="28"
      >
        <rect width="100" height="13"></rect>
        <rect y="30" width="100" height="12"></rect>
        <rect y="60" width="100" height="13"></rect>
        {/* <img className="menu-icon" src={menuIcon} alt="icon" /> */}
      </svg>

      <div
        className={`shadow top-0 left-0 w-[12rem] h-screen bg-[#fff] text-red fixed z-high ${
          showSidebar
            ? "transition duration-1000 ease-in-out translate-x-0 "
            : "transition duration-1000 ease-in-out translate-x-[-100%]"
        }
        ${darkThemeFromStore ? "dark-back" : ""}`}
      >
        <button
          className={`flex text-3xl items-center cursor-pointer z-50
            sm:top-1 ${
              showSidebar
                ? "transition duration-1000 ease-in-out -translate-x-[90%] fixed "
                : "transition duration-1000 ease-in-out translate-x-0 fixed "
            }`}
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <img
            className=" w-5 h-5 my-3    
            "
            width={16}
            height={16}
            src={darkThemeFromStore ? whiteCancelIcon : cancelIcon}
            alt="cancelIcon"
          />
        </button>
        <ul
          className="flex flex-col justify-evenly items-end px-10 text-[16px] text-black  duration-700 font-bold h-[600px]
        md:text-[15px]
        sm:text-[12px] sm:py-3 
        screen345:text-[11px]
        xlg:text-[22px]

        "
        >
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={({ isActive }) =>
              isActive ? "text-[#2a5b2f] " : "text-[#000]"
            }
            to="/"
          >
            <li className="">
              <h1>خانه</h1>
            </li>
          </NavLink>
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={({ isActive }) =>
              isActive ? "text-[#2a5b2f] " : "text-[#000]"
            }
            to="/"
          >
            <li className="">فرم ها</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              scrollToFooter();
            }}
            className={({ isActive }) =>
              isActive ? "text-[#2a5b2f] " : "text-[#000]"
            }
            to="/"
          >
            <li className="">تماس با ما</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
            }}
            className={({ isActive }) =>
              isActive ? "text-[#2a5b2f] " : "text-[#000]"
            }
            to="/"
          >
            <li className="">درباره ما</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              scrollToFooter();
            }}
            className={({ isActive }) =>
              isActive ? "text-[#2a5b2f] " : "text-[#000]"
            }
            to="/"
          >
            <li className="">نصب اپلیکیشن</li>
          </NavLink>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
